import React, {
  useState,
  useEffect,
  useReducer,
  useContext,
  useRef,
} from "react";

// Hooks (use....) worden gebruikt in components (= return JSX) en in custom hooks.
// Only call React Hooks at the top level.
// Don't call them in nested functions. Don't call then in any block statements (bv if statement).
// Rule for useEffect: ALWAYS add everything you refer to inside of useEffect() as a dependency.

import Card from "./UI/Card";
import classes from "./Login.module.css";
import Button from "./UI/Button";
import AuthContext from "../store/auth-context";
import Input from "./UI/Input";

const emailReducer = (state, action) => {
  if (action.type === "USER_INPUT") {
    return { value: action.val, isValid: action.val.includes("@") };
  }
  if (action.type === "INPUT_BLUR") {
    return { value: state.value, isValid: state.value.includes("@") };
  }
  return { value: "", isValid: false };
};

const passwordReducer = (state, action) => {
  if (action.type === "USER_INPUT") {
    return { value: action.val, isValid: action.val.trim().length > 6 };
  }
  if (action.type === "INPUT_BLUR") {
    return { value: state.value, isValid: state.value.trim().length > 6 };
  }
  return { value: "", isValid: false };
};

const Login = (props) => {
  // const [enteredEmail, setEnteredEmail] = useState('');
  // const [emailIsValid, setEmailIsValid] = useState();
  // const [enteredPassword, setEnteredPassword] = useState('');
  // const [passwordIsValid, setPasswordIsValid] = useState();
  const [formIsValid, setFormIsValid] = useState(false);

  // const [state, dispatchFn] = useReducer(reducerFn, initialState, initFn);
  // reducerFn : (prevState, action) => newState
  // reducerFn is a function that is triggered automatically once an action is
  // dispatched (via dispatchFn()). It receives the latest state snapshot
  // and should return the new, updated state.
  const [emailState, dispatchEmail] = useReducer(emailReducer, {
    value: "",
    isValid: null,
  });
  const [passwordState, dispatchPassword] = useReducer(passwordReducer, {
    value: "",
    isValid: null,
  });

  const AuthCtx = useContext(AuthContext);

  const emailInputRef = useRef();
  const passwordInputRef = useRef();

  // Zonder lege array als dependency, wordt useEffect uitgevoerd na elke re-evaluation.
  // Met lege array, wordt het ��n keer uitgevoerd.
  // Met een dependency wordt het uitgevoerd na elke re-evaluation indien de dependency gewijzigd is.
  useEffect(() => {
    console.log("EFFECT RUNNING");

    return () => {
      console.log("EFFECT CLEANUP");
    };
  }, []);

  // Alias assignment. This is not a value assigment.
  // Object de-structuring syntax (staat links van =).
  const { isValid: emailIsValid } = emailState;
  const { isValid: passwordIsValid } = passwordState;

  // useEffect wordt vaak gebruikt bij localStorage, Http requests en timers.
  // Code that should be executed in response to something.
  useEffect(() => {
    const identifier = setTimeout(() => {
      console.log("Checking form validity!");
      setFormIsValid(emailIsValid && passwordIsValid);
    }, 500);

    // This will run as a cleanup process
    // Als je snel typt, zie je veel "CLEANUP" en weinig "Checking form validity!""
    return () => {
      console.log("CLEANUP");
      clearTimeout(identifier);
    };
  }, [emailIsValid, passwordIsValid]);
  // Functie setFormIsValid zonder () zodat het een pointer is (met () wordt de functie uitgevoerd).
  // Zo voeg je de functie zelf toe als een dependency en niet het resultaat van de functie.
  // Deze pointer naar de functie kan echter verwijderd worden, want een set"state" functie wijzigt nooit.

  const emailChangeHandler = (event) => {
    dispatchEmail({ type: "USER_INPUT", val: event.target.value });

    // setFormIsValid(
    //   event.target.value.includes('@') && passwordState.isValid
    // );
  };

  const passwordChangeHandler = (event) => {
    dispatchPassword({ type: "USER_INPUT", val: event.target.value });

    // setFormIsValid(emailState.isValid && event.target.value.trim().length > 6);
  };

  // state setEmailIsValid is afhankelijk van state enteredEmail.
  // Risico bestaat dat de state niet op tijd is bijgewerkt. Gebruik useReducer.
  const validateEmailHandler = () => {
    dispatchEmail({ type: "INPUT_BLUR" });
  };

  const validatePasswordHandler = () => {
    dispatchPassword({ type: "INPUT_BLUR" });
  };

  const submitHandler = (event) => {
    event.preventDefault();
    if (formIsValid) {
      AuthCtx.onLogin(emailState.value, passwordState.value);
    } else if (!emailIsValid) {
      emailInputRef.current.focus();
    } else {
      passwordInputRef.current.focus();
    }
  };

  return (
    <Card className={classes.login}>
      <form onSubmit={submitHandler}>
        <Input
          ref={emailInputRef}
          id="email"
          label="E-mail"
          type="email"
          isValid={emailIsValid}
          value={emailState.value}
          onChange={emailChangeHandler}
          onBlur={validateEmailHandler}
        />
        {/* <div
          className={`${classes.control} ${
            emailState.isValid === false ? classes.invalid : ''
          }`}
        >
          <label htmlFor="email">E-Mail</label>
          <input
            type="email"
            id="email"
            value={emailState.value}
            onChange={emailChangeHandler}
            onBlur={validateEmailHandler}
          />
        </div> */}

        <Input
          ref={passwordInputRef}
          id="password"
          label="Password"
          type="password"
          isValid={passwordIsValid}
          value={passwordState.value}
          onChange={passwordChangeHandler}
          onBlur={validatePasswordHandler}
        />

        {/* <div
          className={`${classes.control} ${
            passwordState.isValid === false ? classes.invalid : ''
          }`}
        >
          <label htmlFor="password">Password</label>
          <input
            type="password"
            id="password"
            value={passwordState.value}
            onChange={passwordChangeHandler}
            onBlur={validatePasswordHandler}
          />
        </div> */}
        <div className={classes.actions}>
          <Button type="submit" className={classes.btn}>
            Login
          </Button>
        </div>
      </form>
    </Card>
  );
};

export default Login;